// Shared mobile/desktop breakpoint for JS layout (sortable, footer, search).
// CSS @media (max-width: 490px) blocks must stay in sync with MOBILE_MAX_WIDTH_PX.
const MOBILE_MAX_WIDTH_PX = 490

const mobileMq = () => window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`)

const isMobileViewport = () => mobileMq().matches

module.exports = { MOBILE_MAX_WIDTH_PX, mobileMq, isMobileViewport }
